import { collection, onSnapshot, query } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NavbarComponent from "../component/NavbarComponent";
import { db } from "../firebase";
import { motion } from "framer-motion";

const UploadSyllabus = () => {
  const [syllabusList, setSyllabusList] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "syllabusUpload"));
    onSnapshot(q, (querySnapshot) => {
      let filesArry = [];
      querySnapshot.forEach((doc) => {
        filesArry.push({ id: doc.id, ...doc.data() });
      });
      setSyllabusList(filesArry);
    });
  }, []);

  let tenthArr = [];
  tenthArr = syllabusList?.filter((item) => item?.className === "10th");

  let twelvethArr = [];
  twelvethArr = syllabusList?.filter((item) => item?.className === "11th/12th");

  return (
    <React.Fragment>
      <NavbarComponent />

      <div className="min-h-screen text-lg font-bold p-3  mt-4  lg:pl-20 md:pl-20  lg:pr-20 md:pr-20">
        <div>
          <div className="flex justify-between w-full bg-[#053375] rounded-md ">
            <div className="text-xl font-bold text-left px-10 text-white  py-2">
              10<sup>th</sup> <span>Syllabus</span>
            </div>
          </div>
          <div className="grid lg:grid-cols-7 gap-4 sm:grid-cols-5  md:grid-cols-5 grid-cols-3 pt-5">
            {tenthArr?.map((item, index) => (
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                key={index}
                className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
              >
                <div className="flex flex-col justify-center">
                  <div className="hidden">{++index}</div>
                  <div className="flex justify-center">
                    <a href={item.pictureUrl} target="blank">
                      <img
                        src="../assets/pdf.png"
                        className="h-20 w-20"
                        alt="pdf"
                      />
                    </a>
                  </div>
                  <h1 className="text-sm p-1">{item.bookName}</h1>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="pt-10">
          <div className="flex justify-between w-full bg-[#053375] rounded-md ">
            <div className="text-xl font-bold text-left px-10 text-white  py-2">
              12<sup>th</sup> <span>Syllabus</span>
            </div>
          </div>
          <div className="grid lg:grid-cols-7 gap-4 sm:grid-cols-5  md:grid-cols-5 grid-cols-3 pt-5">
            {twelvethArr?.map((item, index) => (
              <motion.div
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                key={index}
                className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
              >
                <div className="flex flex-col justify-center">
                  <div className="hidden">{++index}</div>
                  <div className="flex justify-center">
                    <a href={item.pictureUrl} target="blank">
                      <img
                        src="../assets/pdf.png"
                        className="h-20 w-20"
                        alt="pdf"
                      />
                    </a>
                  </div>
                  <h1 className="text-sm p-1">{item.bookName}</h1>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default UploadSyllabus;
